export default "__VITE_PUBLIC_ASSET__f38ece00__"